import { GenericDrawer } from '@dealstack/frontend/shared/components/GenericDrawer/GenericDrawer';
import { TextV2 } from '@dealstack/frontend/shared/components/TextV2/TextV2';
import {
	DistributionRuleScope,
	DistributionRuleTable,
} from '@dealstack/frontend/app/pages/Valuations/views/BreakpointSummary/DistributionRule/DistributionRuleTable';
import { useTranslationValuations } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { BreakpointSummaryPayload, CurrencyType } from '@dealstack/shared/lib/generated';
import { InlineLoader } from '@dealstack/frontend/shared/components/loaders/InlineLoader/InlineLoader';

export const DistributionRuleDrawer = ({
	opened,
	onClose,
	breakpointSummaryData,
	isLoading,
	currency,
	scope,
}: {
	opened: boolean;
	onClose: () => void;
	breakpointSummaryData: BreakpointSummaryPayload | undefined;
	isLoading: boolean;
	currency: CurrencyType;
	scope?: DistributionRuleScope;
}) => {
	const tValuations = useTranslationValuations();

	return (
		<GenericDrawer
			opened={opened}
			onClose={() => {
				onClose();
			}}
			title={
				<TextV2 variant="sans/25/600">
					{tValuations('breakpoint_summary.distribution_rules_drawer.title')}
				</TextV2>
			}
			body={
				isLoading ? (
					<InlineLoader />
				) : (
					breakpointSummaryData && (
						<DistributionRuleTable
							breakpointSummaryData={breakpointSummaryData}
							currency={currency}
							scope={scope}
						/>
					)
				)
			}
		/>
	);
};
